import { useQuery } from "@apollo/client";

import {
  GET_BRANCH_OFICCES,
  GET_SERVICE_ACTIONS,
  GET_CAR_OWNERS,
  GET_CAR_RENTERS,
} from "../../../graphql/AdminQueries";

const GetGraphQlData = (graphqlVariables, loadData) => {
  const serviceActions = useQuery(GET_SERVICE_ACTIONS, {
    variables: graphqlVariables,
    skip: !loadData,
  });

  const branchOfices = useQuery(GET_BRANCH_OFICCES, {
    variables: graphqlVariables,
    skip: !loadData,
  });

  return [serviceActions, branchOfices];
};

// Ciselniky do filtrov zakaziek: majitelia a najomcovia.
// Pobocky uz chodia vyssie, netahame ich druhykrat.
const GetCiselnikyZakaziek = (graphqlVariables, loadData) => {
  const majitelia = useQuery(GET_CAR_OWNERS, {
    variables: graphqlVariables,
    skip: !loadData,
  });
  const najomcovia = useQuery(GET_CAR_RENTERS, {
    variables: graphqlVariables,
    skip: !loadData,
  });

  return [majitelia, najomcovia];
};

export { GetGraphQlData, GetCiselnikyZakaziek };
